exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.livePreview .weui-icon-success-no-circle {\n  display: none !important;\n}\n.livePreview .vux-timeline-item-head-first {\n  width: 10px !important;\n  height: 10px !important;\n  left: 1px !important;\n  top: 4px !important;\n}\n.livePreview .vux-timeline-item-color {\n  background-color: #027cfa !important;\n}\n.livePreview .vux-timeline-item-tail {\n  background-color: #027cfa !important;\n}\n.livePreview .vux-timeline-item-content {\n  padding: 0 0 0.56rem 0.85rem;\n}\n", ""]);

// exports
